import { WHITE } from '../../../../Constants/Colors.constants';
import { makeStyles } from '~/UIKit/Style';

export const EventPageInformationStyles = makeStyles((theme) => ({
  header: {
    overflow: 'hidden',
    position: 'relative',
    fontSize: 16,
    minHeight: 205,
    height: 205,
    maxHeight: 205,
    [theme.breakpoints.up('md')]: {
      minHeight: 152,
      height: 152,
      maxHeight: 152,
      width: 220,
    },
  },
  infoWrapper: {
    zIndex: 1,
    position: 'absolute',
    maxWidth: '100%',
    minWidth: '100%',
    padding: 15,
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  EventPageInformationTitle: {
    color: WHITE,
    display: 'flex',
  },
  EventPageInfoTextWrapper: {
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'flex-end',
    whiteSpace: 'nowrap',
  },
  EventPageInfoLocationWrapper: {
    flex: 1,
    margin: '0 15px',
    maxWidth: 'fit-content',
  },
  title: {
    color: WHITE,
    fontSize: 26,
    fontWeight: 'bold',
    overflow: 'hidden',
    lineHeight: '34px',
    maxHeight: '68px',
    alignContent: 'center',
  },
  EventPageTitle: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
  },
}));
